import { render, staticRenderFns } from "./AttendanceListAddNew.vue?vue&type=template&id=6c589c09"
import script from "./AttendanceListAddNew.vue?vue&type=script&lang=js"
export * from "./AttendanceListAddNew.vue?vue&type=script&lang=js"
import style0 from "./AttendanceListAddNew.vue?vue&type=style&index=0&id=6c589c09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports